"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.createTicket = createTicket;
exports.createTicketWithAssociations = createTicketWithAssociations;
exports.updateTicketProperties = updateTicketProperties;
exports.deleteTicket = deleteTicket;

var _immutable = require("immutable");

var _TicketRecord = _interopRequireDefault(require("customer-data-objects/ticket/TicketRecord"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _TicketsAPIQuery = require("./TicketsAPIQuery");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var BASE_URI = 'services/v1/tickets';
var contactsCrmUiSourceHeaders = {
  'X-Properties-Source': _PropertySourceTypes.CONTACTS,
  'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
};

var parseItems = function parseItems(result) {
  return result.reduce(function (coll, val) {
    var ticket = _TicketRecord.default.fromJS(val);

    return coll.set(String((0, _ImmutableModel.getId)(ticket)), ticket);
  }, (0, _immutable.Map)());
};

function fetch(ids) {
  var toUri = function toUri(queryStr) {
    return BASE_URI + "/batch?" + queryStr + "&allPropertiesFetchMode=latest_version";
  };

  var fallback = function fallback() {
    return ImmutableAPI.get(toUri((0, _TicketsAPIQuery.byIdsStr)(ids)));
  };

  if (ids.size === 1) {
    var objectId = ids.first();
    return (0, _MetaAPI.queueFetch)(_ObjectTypes.TICKET, fallback, {
      ticketId: parseInt(objectId, 10)
    }, function (result) {
      return (0, _immutable.Map)().set(objectId, _TicketRecord.default.fromJS(result.get(objectId)));
    });
  }

  return fallback().then(parseItems);
}

function createTicket(objectPayload) {
  var payload = {
    object: objectPayload
  };
  return ImmutableAPI.send({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.POST
  }, BASE_URI, payload, _TicketRecord.default.fromJS);
}

function createTicketWithAssociations(_ref) {
  var propertyValues = _ref.propertyValues,
      requestedAssociatedObjects = _ref.requestedAssociatedObjects;
  return ImmutableAPI.send({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.POST
  }, 'inbounddb-objects/v1/create-and-bulk-associate', {
    createObjectType: _ObjectTypes.TICKET,
    propertyValues: propertyValues,
    requestedAssociatedObjects: requestedAssociatedObjects
  }, function (result) {
    return _TicketRecord.default.fromJS(result);
  });
}

function updateTicketProperties(ticket, propertyUpdates) {
  var ticketId = ticket.get('objectId');
  return ImmutableAPI.send({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.PUT
  }, BASE_URI + "/" + ticketId + "?allPropertiesFetchMode=latest_version", {
    ticketId: ticketId,
    properties: propertyUpdates.reduce(function (acc, value, name) {
      acc.push({
        name: name,
        value: value,
        source: _PropertySourceTypes.CRM_UI,
        sourceId: _user.default.get().get('email')
      });
      return acc;
    }, [])
  }, _TicketRecord.default.fromJS);
}

function deleteTicket(ticketId) {
  return ImmutableAPI.delete(BASE_URI + "/" + ticketId);
}